import FlexContainer from './flex-container';

export default FlexContainer;
